import { apiService } from '../../..'
import { GetPaymentRescheduleRequest, GetPaymentRescheduleResponseBody, SetPaymentRescheduleRequest } from '../types'

export const paymentRescheduleService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getPaymentReschedule: build.query<GetPaymentRescheduleResponseBody, GetPaymentRescheduleRequest>({
      query: (req) => {
        return {
          url: `portal/consumers/payment-schedule-due-date/${req.params.paymentScheduleId}/change`,
          method: 'get',
        }
      },
      providesTags: ['PaymentReschedule'],
    }),
    setPaymentReschedule: build.mutation<void, SetPaymentRescheduleRequest>({
      query: (req) => {
        return {
          url: `portal/consumers/payment-schedule-due-date/${req.params.paymentScheduleId}/change`,
          method: 'post',
          data: req.body,
        }
      },
      invalidatesTags: (_res, _err, req) => ['PaymentSchedule', 'PaymentReschedule', 'AmountDueSummary', ...req.cache.invalidatesTags],
    }),
  }),
})
